export default "__VITE_ASSET__C4pBHQA8__"